import { useShortCodeDataCemeteries } from '@/hooks/use-short-code-data/use-short-code-data'
import { sectionTypes } from '@lifedot/constants/searchChoices'
import { FC } from 'react'
import Link from 'next/link'
import { router } from '@lifedot/router'
import { css } from '@emotion/react'
import { distanceFormatter, makeAccessText } from '@lifedot/utils'
import { EventTracker } from '@lifedot/tracking'
import { elementCategories } from '@lifedot/constants/elementCategories'

const styles = {
  fontWeightBold: css({
    fontWeight: 'bold'
  })
}

interface AccessTextProps {
  cemeteryId: number
  choiceCode: string
}

export const AccessText: FC<AccessTextProps> = ({ cemeteryId, choiceCode }) => {
  const [cemetery] = useShortCodeDataCemeteries([cemeteryId])
  if (!cemetery) return null
  const {
    name,
    prefecture,
    city,
    accesses,
    nearest_station: nearestStation
  } = cemetery

  const sectionType = sectionTypes.find(({ code }) => code === choiceCode)

  return (
    <p>
      <EventTracker
        clone
        action="click"
        label={`cemeteryIntroduction_name_${cemeteryId}`}
        elementCategory={elementCategories.cemeteryIntroduction}
        elementLabel={`name_${cemeteryId}`}
      >
        <Link href={router.cemetery(cemeteryId)} passHref prefetch={false}>
          <a css={styles.fontWeightBold}>{name}</a>
        </Link>
      </EventTracker>
      は、
      <span css={styles.fontWeightBold}>
        {prefecture.name}
        {city.name}
      </span>
      {nearestStation.name && nearestStation.distance && (
        <>
          にあり、 最寄駅の
          <span css={styles.fontWeightBold}>{nearestStation.name}</span>
          駅から約
          {distanceFormatter(nearestStation.distance)}の場所
        </>
      )}
      にある{sectionType?.name ?? 'お墓'}です。
      {accesses.other && (
        <>
          <br />
          公共交通機関の場合{makeAccessText(accesses.other)}です。
        </>
      )}
      {accesses.car && (
        <>
          <br />
          車の場合{makeAccessText(accesses.car)}です。
        </>
      )}
    </p>
  )
}
